import React from 'react';
import { FormInstance, Typography } from 'antd';
import { Membership } from 'works/legacy/graphql/works-membership';
import { MemberViewDrawerInfoRow } from './member-view-drawer-info-row';
import { formatPhone } from 'works/legacy/services/phone-service';
import { Colors } from '@common/tokens';
import { MemberViewEditForm } from './member-view-edit-form';

const { Text } = Typography;

type MemberViewDetailsProps = {
  membership: Membership | undefined;
  editMode: boolean;
  form: FormInstance;
  entityType: string;
};

export function MemberViewDetails({
  membership,
  editMode,
  form,
  entityType,
}: MemberViewDetailsProps) {
  const formattedPhone = membership?.phone
    ? formatPhone(membership.phone)
    : 'N/A';

  return (
    <>
      <div className="member-view-drawer__content-container">
        {editMode ? (
          <MemberViewEditForm form={form} entityType={entityType} />
        ) : (
          <>
            {!membership?.active && (
              <MemberViewDrawerInfoRow
                label="Status"
                info={
                  <Text
                    strong
                    style={{
                      color: Colors.midnightLighter,
                    }}
                  >
                    Inactive
                  </Text>
                }
              />
            )}
            <MemberViewDrawerInfoRow
              label="Email"
              info={membership?.email || ''}
              className="sentry-mask"
            />
            <MemberViewDrawerInfoRow
              label="Employee ID"
              info={membership?.employeeId || 'N/A'}
              className="sentry-mask"
            />
            <MemberViewDrawerInfoRow
              label="Phone Number"
              info={formattedPhone}
              className="sentry-mask"
            />
            <MemberViewDrawerInfoRow
              label="Role"
              info={membership?.roleName || ''}
            />
            {membership?.title && (
              <MemberViewDrawerInfoRow
                label="Title"
                info={membership?.title || ''}
              />
            )}
            <MemberViewDrawerInfoRow
              label="Time Zone"
              info={membership?.timeZoneIdentifier || ''}
            />
          </>
        )}
      </div>
      <style jsx>{`
        :global(.member-view-drawer__content-container) {
          padding-top: 16px;
        }
      `}</style>
    </>
  );
}
